import { render, staticRenderFns } from "./DataTreatmentModal.vue?vue&type=template&id=1b1df7f5&"
import script from "./DataTreatmentModal.vue?vue&type=script&lang=ts&"
export * from "./DataTreatmentModal.vue?vue&type=script&lang=ts&"
import style0 from "./DataTreatmentModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports